export default {
      id: "svg-icon-ico-fb-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-ico-fb",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/ico-fb.svg
// module id = Z5h4
// module chunks = 4